import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SHIFT_URL} from '../../connection.data';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Shift } from '../_models/shift.model';
//const API_USERS_URL = 'api/users';
//const API_PERMISSION_URL = 'api/permissions';
//const API_ROLES_URL = 'api/roles';

//const BASE_URL = "http://localhost:3000"                //INTERNAL DEV
//const BASE_URL = "http://ir4hub.cl:45016"                //LAB DEV

@Injectable()
export class ShiftService{
    constructor(private http: HttpClient){

    }

    getAll():Observable<Shift[]>{
        const url = `${API_SHIFT_URL}/all`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getTypes():Observable<Shift[]>{
        const url = `${API_SHIFT_URL}/types`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getPage(queryParams: QueryParamsModel):Observable<QueryResultsModel>{
        const url = `${API_SHIFT_URL}/page`;
        return this.http.post<QueryResultsModel>(url, queryParams)
    }

    add(shift:Shift):Observable<number>{
        return this.http.post<any>(API_SHIFT_URL, shift).pipe(
            map((response)=> response.id)
        );
    }

    edit(shift:Shift):Observable<string>{
        return this.http.put<any>(`${API_SHIFT_URL}/${shift.id}`, shift).pipe(
            map((response)=>response.status)
        );
    }

    delete(shift:Shift):Observable<string>{
        return this.http.delete<any>(`${API_SHIFT_URL}/${shift.id}`).pipe(
            map((response)=>response.status)
        );
    }

    currentId():Observable<any>{
        const url = `${API_SHIFT_URL}/current`;
        return this.http.get<{shiftId:number, date:string}>(url).pipe(
            map((response)=>{
                return response;
            })
        )
    }

    getShiftCurrentDates(shiftId):Observable<any>{
        const url = `${API_SHIFT_URL}/dates/${shiftId}`;
        return this.http.get<{status:string, st:string, et:string}>(url).pipe(
            map((response)=>{
                return response;
            })
        )
    }

    getShiftDatesIgnoreHour(shift, referenceDate = new Date()) {
        // const daysOfWeek = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];
        var dayOfWeek = referenceDate.getDay();
        // const startDayStr = shift.start_time_day;
        // const endDayStr = shift.end_time_day;
        // const startDayIdx = daysOfWeek.indexOf(startDayStr.toLowerCase());
        const startDayIdx = shift.start_time_day > 6? 0: shift.start_time_day;
        let endDayIdx = shift.end_time_day > 6? 0: shift.end_time_day;
      
        var st = null;
        var et = null;
      
        // let endDayIdx = daysOfWeek.indexOf(endDayStr.toLowerCase());
      
        // if(dayOfWeek == 0) dayOfWeek = 6;
      
        if ((startDayIdx <= endDayIdx && dayOfWeek >= startDayIdx && dayOfWeek <= endDayIdx) ||
          (startDayIdx > endDayIdx && (dayOfWeek >= startDayIdx || dayOfWeek <= endDayIdx))) {
          const seconds = referenceDate.getSeconds();
          const minutes = referenceDate.getMinutes();
          const hour = referenceDate.getHours();
      
          const st_minutes = shift.start_time_hour * 60 + shift.start_time_minute;
          const et_minutes = shift.end_time_hour * 60 + shift.end_time_minute;
          const current_minutes = hour * 60 + minutes + seconds / 60.0;
          if (st_minutes <= et_minutes) {
            st = new Date(referenceDate);
            st.setHours(shift.start_time_hour, shift.start_time_minute, 0);
            et = new Date(referenceDate);
            et.setHours(shift.end_time_hour, shift.end_time_minute, 0);
            console.log("st: " + st); console.log("et: " + et);
          } else {
            st = new Date(referenceDate);
            st.setHours(shift.start_time_hour, shift.start_time_minute, 0);
            et = new Date(referenceDate);
            et.setHours(shift.end_time_hour, shift.end_time_minute, 0);
            if (current_minutes <= et_minutes) {
              //Está en el segundo dia
              st.setDate(st.getDate() - 1);
            } else {
              //Está en el primer dia
              et.setDate(st.getDate() + 1);
            }
          }
        } else {
          //referencia está fuera de turno
          console.log(`referencia fuera de turno por el dia`)
        }
        return { st, et };
    }
}